import React, { useState } from 'react'
import { Map, Expand } from 'lucide-react'
import Lightbox from './Lightbox'

const css = (imgMaxHeight, placeholderHeight) => `
  .ljn-routemap__frame {
    position: relative; overflow: hidden;
    border-radius: 4px;
    backdrop-filter: blur(40px) saturate(1.3);
  }
  .ljn-routemap__frame::before {
    content: '';
    position: absolute; inset: 0;
    background: linear-gradient(180deg, rgba(10,87,118,0.5) 0%, #052531 100%);
    z-index: 99;
  }
  .ljn-routemap__img {
    display: block; margin: 0 auto;
    max-width: 100%; max-height: ${imgMaxHeight}px;
    object-fit: contain;
    filter: drop-shadow(0 8px 32px rgba(7,30,48,0.22));
    position: relative; z-index: 100;
  }
  .ljn-routemap__expand {
    position: absolute; bottom: 14px; left: 14px; z-index: 110;
    width: 34px; height: 34px;
    background: rgba(7,30,48,0.68);
    border: 1px solid rgba(255,255,255,0.18);
    color: rgba(255,255,255,0.82);
    display: flex; align-items: center; justify-content: center;
    border-radius: 4px; cursor: pointer;
    transition: background 0.18s, color 0.18s;
    backdrop-filter: blur(6px);
  }
  .ljn-routemap__expand:hover {
    background: var(--color-teal);
    color: #fff;
    border-color: var(--color-teal);
  }
  .ljn-routemap__placeholder {
    height: ${placeholderHeight}px;
    border: 1px solid var(--color-divider);
    display: flex; flex-direction: column;
    align-items: center; justify-content: center; gap: 12px;
    color: var(--color-slate); font-size: 13px; letter-spacing: 0.05em;
  }
  .ljn-routemap__placeholder svg { opacity: 0.3; }
`

export default function Routemap({
  imageUrl,
  embedUrl,
  sectionClass = 'sc-section',
  imgMaxHeight = 620,
  placeholderHeight = 420,
}) {
  const [lightboxOpen, setLightboxOpen] = useState(false)

  return (
    <section className={sectionClass}>
      <style>{css(imgMaxHeight, placeholderHeight)}</style>
      <h2 className="ljn-section-title">Route Map</h2>
      <div className="ljn-divider" style={{ marginBottom: 32 }} />

      {embedUrl ? (
        <iframe
          src={embedUrl}
          width="100%"
          height="480"
          style={{ border: 'none', display: 'block' }}
          allowFullScreen
          loading="lazy"
          title="Route Map"
        />
      ) : imageUrl ? (
        <>
          <div className="ljn-routemap__frame">
            <img src={imageUrl} alt="Route map" className="ljn-routemap__img" onClick={() => setLightboxOpen(true)} style={{ cursor: 'zoom-in' }} />
            <button
              className="ljn-routemap__expand"
              onClick={() => setLightboxOpen(true)}
              aria-label="View full map"
            >
              <Expand size={16} strokeWidth={1.8} />
            </button>
          </div>
          {lightboxOpen && (
            <Lightbox
              images={[imageUrl]}
              startIdx={0}
              caption="Route Map"
              onClose={() => setLightboxOpen(false)}
            />
          )}
        </>
      ) : (
        <div className="ljn-routemap__placeholder">
          <Map size={40} strokeWidth={1} />
          <p>Route map coming soon</p>
        </div>
      )}
    </section>
  )
}
